import React from "react";
import Footer from "../../components/Footer";
import HomeView from "./HomeView";

export function HomeContainer() {
  return (
    <div>
      <HomeView title="Home" />
      <Footer/>
    </div>
  );
}
